import React, { Component } from "react";
import { PropTypes } from "prop-types";
import moment from "moment";

import { customize } from "utils/hoc/Customize";

import "css/common/tag.scss";

class Tag extends Component {
  constructor(props) {
    super(props);

    this.state = {
      style: null,
    };
  }

  componentDidMount() {
    const { getStyles, item, type } = this.props;
    let { style } = this.state;
    let live_finished = false;

    switch (type) {
      case "live":
        live_finished = item
          ? moment().isAfter(
              moment.utc(item.live_end || item.live_stream?.live_end),
            )
          : false;
        style = {
          color: "#FFFFFF",
          backgroundColor: `${live_finished ? "#5D5D5D" : "#E00"}`,
        };
        break;
      case "free":
      case "replay": {
        style = getStyles("free_content:obutton_primary").backgroundColor
          ? getStyles("free_content:obutton_primary")
          : { color: "var(--foreground)", backgroundColor: "var(--card)" };
        break;
      }
      default:
        style = { color: "#FFFFFF", backgroundColor: "#5D5D5D" };
        break;
    }

    this.setState({ style });
  }

  render() {
    const { children } = this.props;
    const { style } = this.state;

    return (
      <div className="tag-container" style={style}>
        {children}
      </div>
    );
  }
}

Tag.propTypes = {
  children: PropTypes.node.isRequired,
  getStyles: PropTypes.func.isRequired,
  item: PropTypes.object,
  type: PropTypes.string,
};

export default customize()(Tag);
